var SubCategoriesView = require('./sub-categories');
var BaseView = require('../../../templates/view-base');
var CreateMixin = require('../../../components/mixins/create');

module.exports = Backbone.mixin(BaseView.extend({
  CategoriesView: SubCategoriesView,
  views: {},

  addNewEvent: function (event, data) {
    this.modalData = new INKIVE.ModalAdminLayout({ data: data });
    this.modal = INKIVE.Modal.modalWindow(this.modalData.getFormHtml(), {
      width: 500,
      headerIcon: 'icon-news',
      headerTitle: 'modal.title.new_template',
      buttons: [{
        title: INKIVE.TranslateHelper.translate('modal.buttons.create_template'),
        onClick: _.bind(this.createTemplate, this)
      }]
    });
  },

  listContentToggleEvent: function (event) {
    BaseView.prototype.listContentToggleEvent.apply(this, arguments);
    event.stopPropagation();
  },

  initialize: function () {
    this.createButtonMargin = 31;
    this.modalData = new INKIVE.ModalAdminLayout();
    this.mode = 'template';
    this.addButtonText = 'tool.admin.new_template';
    this.createCallback = $.noop;

    BaseView.prototype.initialize.call(this);
    this.render();

    this.$el.find('.wrapper').css('top', this.createButtonMargin + 'px');
  },

  toggleAcordionElement: function ($button, value) {
    var $container = $button.closest('dt');
    var $wrapper = $container.closest('.wrapper');
    var top = this.createButtonMargin - $container.position().top;

    BaseView.prototype.toggleAcordionElement.apply(this, arguments);
    $wrapper.css('top', value
      ? top + 'px'
      : this.createButtonMargin + 'px'
    );
  },

  extractData: function (data) { return []; }
}), CreateMixin);
